export const CHANGED_USERNAME_FOR_LOGIN = 'CHANGED_USERNAME_FOR_LOGIN'
export const CHANGED_PASSWORD_FOR_LOGIN = 'CHANGED_PASSWORD_FOR_LOGIN'
export const CHANGED_EMAIL_FOR_LOGIN = 'CHANGED_EMAIL_FOR_LOGIN'
export const STARTED_AUTHENTICATING_USER = 'STARTED_AUTHENTICATING_USER'
export const FINISHED_AUTHENTICATING_USER_ON_FIREBASE = 'FINISHED_AUTHENTICATING_USER_ON_FIREBASE'
export const ERRED_AUTHENTICATING_USER = 'ERRED_AUTHENTICATING_USER'
export const SIGNED_OUT_USER = "SIGNED_OUT_USER"